import React from 'react';
import { Route } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import { IRoute, useAppContext } from '@front-activerse/common-components';

interface IMealPlanPage {
  descendantRoutes: IRoute[];
}

export const DayPlanPage: React.FC<IMealPlanPage> = ({ descendantRoutes }) => {
  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  return (
    <SlideRoutes duration={+SLIDE_ROUTES_DURATION} animation="slide" destroy={false}>
      {descendantRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </SlideRoutes>
  );
};

export default DayPlanPage;
